require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./accountability-and-bwc.json") })
        }
      }, "path---accountability-and-bwc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---accountability-and-bwc!./.cache/json/accountability-and-bwc.json
// module id = 836
// module chunks = 231608221292675